import { FunctionComponent, PropsWithChildren } from "react";
import { cn } from "../../utils/cn";

export interface ContentProps {
  className?: string;
}

/**
 *
 */
export const Container: FunctionComponent<PropsWithChildren<ContentProps>> = ({
  className,
  children,
}) => {
  return (
    <div className={cn("container mx-auto p-2 sm:p-4", className)}>
      {children}
    </div>
  );
};
